import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import SoporteLayout from '../layouts/SoporteLayout';
import ReusableTable from '../components/ReusableTable';
import { getMisTareasResponsablePorCalificacion } from '../services/tareasResponsableService';
import { jwtDecode } from 'jwt-decode';
import { formatearBogota } from '../utils/fecha';
import './HomePage.css';

const esAdmin = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken.rolId === '1';
  } catch {
    return false;
  }
};

const esSoporteTecnico = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return false;
  try {
    const decodedToken = jwtDecode(token);
    return decodedToken.rolId === '3';
  } catch {
    return false;
  }
};

const TareasCalificacionPage = () => {
  const navigate = useNavigate();
  const [tareas, setTareas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filtroCalificada, setFiltroCalificada] = useState(''); // '' | 'true' | 'false'

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    navigate('/auth/login');
  };

  const links = [
    { to: '/home', label: 'Home' },
    { to: '/tareas', label: 'Ver Tarea' },
    { to: '/tareas-calificacion', label: 'Tareas por Calificación' },
  ];
  
  // Links de admin iguales a los usados en AdminPanel
  const adminLinks = [
    { to: '/home', label: 'Home'},
    { to: '/admin/parametros', label: 'Parametros' },
    { to: '/admin/area', label: 'Area' },
    { to: '/admin/categoria', label: 'Categoria' },
    { to: '/admin/rol', label: 'Rol' },
    { to: '/admin/tareas-area', label: 'Tareas del Área' },
    { to: '/tareas-calificacion', label: 'Tareas por Calificación' },
    { to: '/admin/estadisticas', label: 'Estadísticas' },
    { to: '/auth/register', label: 'Crear Usuario' },
    { to: '/admin/administrar-usuarios', label: 'Administrar Usuarios' }
  ];
  if (esAdmin()) {
    links.push({ to: '/admin', label: 'Admin Panel' });
  }
  if (esSoporteTecnico()) {
    links.push({ to: '/soporte', label: 'Soporte' });
  }

  const columns = [
    { key: 'idTarea', label: 'ID Tarea' },
    { key: 'observaciones', label: 'Observaciones' },
    { key: 'estado', label: 'Estado' },
    { key: 'areaNombre', label: 'Área' },
    { key: 'sedeNombre', label: 'Sede' },
    {
      key: 'fechaCreacion',
      label: 'Fecha Creación',
      formatter: (date) => (date ? formatearBogota(date) : 'N/A')
    },
    { key: 'calificacion', label: 'Calificación', formatter: (v) => v ?? '—' },
    { key: 'comentarioCalificacion', label: 'Comentario' },
    { key: 'calificadoPorNombre', label: 'Calificado por' },
  ];

  const cargar = async (valor) => {
    setLoading(true);
    setError(null);
    const resp = await getMisTareasResponsablePorCalificacion(valor === 'true');
    if (resp.success) {
      const tareasOrdenadas = resp.data.slice().sort((a, b) => b.idTarea - a.idTarea);
      setTareas(tareasOrdenadas);
    } else {
      setError(resp.message);
      setTareas([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (filtroCalificada === 'true' || filtroCalificada === 'false') {
      cargar(filtroCalificada);
    } else {
      setTareas([]);
    }
  }, [filtroCalificada]);

  const content = (
    <div>
      <h1>Tareas por Calificación</h1>
      <div style={{ marginBottom: '16px' }}>
        <select
          value={filtroCalificada}
          onChange={(e) => setFiltroCalificada(e.target.value)}
          style={{ padding: '8px', borderRadius: 4, border: '1px solid #ccc' }}
        >
          <option value="">Seleccione filtro</option>
          <option value="true">Calificadas (estado 10)</option>
          <option value="false">No calificadas (estado 10)</option>
        </select>
      </div>

      {loading && <p>Cargando...</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!loading && !error && tareas.length > 0 && (
        <ReusableTable data={tareas} columns={columns} keyField="idTarea" />
      )}
      {!loading && !error && tareas.length === 0 && filtroCalificada && (
        <p>No hay tareas para este filtro.</p>
      )}
    </div>
  );

  if (esSoporteTecnico()) {
    return <SoporteLayout>{content}</SoporteLayout>;
  }
  
  // Si es admin, usar el mismo layout y links que AdminPanel para mantener el sidebar
  if (esAdmin()) {
    return (
      <div className="admin-layout">
        <Sidebar links={adminLinks} onLogout={handleLogout} />
        <main className="admin-content">
          {content}
        </main>
      </div>
    );
  }

  return (
    <div className="home-container">
      <Sidebar links={links} onLogout={handleLogout} />
      <main className="home-content">{content}</main>
    </div>
  );
};

export default TareasCalificacionPage;



